'use strict';

var cov_1n660e8fu6 = function () {
  var path = 'C:\\Users\\Bruno\\Documents\\Projects\\SAWAP\\src\\index.js',
      hash = 'b4c21e058404e158a9825ac800d552684c106086',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: 'C:\\Users\\Bruno\\Documents\\Projects\\SAWAP\\src\\index.js',
    statementMap: {
      '0': {
        start: {
          line: 1,
          column: 0
        },
        end: {
          line: 24,
          column: 6
        }
      },
      '1': {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 23,
          column: 145
        }
      },
      '2': {
        start: {
          line: 25,
          column: 0
        },
        end: {
          line: 53,
          column: 2
        }
      },
      '3': {
        start: {
          line: 26,
          column: 15
        },
        end: {
          line: 26,
          column: 19
        }
      },
      '4': {
        start: {
          line: 27,
          column: 2
        },
        end: {
          line: 43,
          column: 3
        }
      },
      '5': {
        start: {
          line: 28,
          column: 4
        },
        end: {
          line: 28,
          column: 24
        }
      },
      '6': {
        start: {
          line: 29,
          column: 9
        },
        end: {
          line: 43,
          column: 3
        }
      },
      '7': {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 30,
          column: 26
        }
      },
      '8': {
        start: {
          line: 31,
          column: 9
        },
        end: {
          line: 43,
          column: 3
        }
      },
      '9': {
        start: {
          line: 32,
          column: 4
        },
        end: {
          line: 32,
          column: 30
        }
      },
      '10': {
        start: {
          line: 33,
          column: 9
        },
        end: {
          line: 43,
          column: 3
        }
      },
      '11': {
        start: {
          line: 34,
          column: 4
        },
        end: {
          line: 34,
          column: 34
        }
      },
      '12': {
        start: {
          line: 35,
          column: 9
        },
        end: {
          line: 43,
          column: 3
        }
      },
      '13': {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 36,
          column: 38
        }
      },
      '14': {
        start: {
          line: 37,
          column: 9
        },
        end: {
          line: 43,
          column: 3
        }
      },
      '15': {
        start: {
          line: 38,
          column: 4
        },
        end: {
          line: 38,
          column: 42
        }
      },
      '16': {
        start: {
          line: 39,
          column: 9
        },
        end: {
          line: 43,
          column: 3
        }
      },
      '17': {
        start: {
          line: 40,
          column: 4
        },
        end: {
          line: 40,
          column: 46
        }
      },
      '18': {
        start: {
          line: 42,
          column: 4
        },
        end: {
          line: 42,
          column: 50
        }
      },
      '19': {
        start: {
          line: 44,
          column: 2
        },
        end: {
          line: 50,
          column: 3
        }
      },
      '20': {
        start: {
          line: 45,
          column: 19
        },
        end: {
          line: 45,
          column: 38
        }
      },
      '21': {
        start: {
          line: 46,
          column: 16
        },
        end: {
          line: 46,
          column: 32
        }
      },
      '22': {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 49,
          column: 5
        }
      },
      '23': {
        start: {
          line: 48,
          column: 6
        },
        end: {
          line: 48,
          column: 74
        }
      },
      '24': {
        start: {
          line: 52,
          column: 2
        },
        end: {
          line: 52,
          column: 16
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 22,
            column: 41
          },
          end: {
            line: 22,
            column: 42
          }
        },
        loc: {
          start: {
            line: 22,
            column: 77
          },
          end: {
            line: 24,
            column: 3
          }
        },
        line: 22
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 25,
            column: 15
          },
          end: {
            line: 25,
            column: 16
          }
        },
        loc: {
          start: {
            line: 25,
            column: 53
          },
          end: {
            line: 53,
            column: 1
          }
        },
        line: 25
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 27,
            column: 2
          },
          end: {
            line: 43,
            column: 3
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 27,
            column: 2
          },
          end: {
            line: 43,
            column: 3
          }
        }, {
          start: {
            line: 27,
            column: 2
          },
          end: {
            line: 43,
            column: 3
          }
        }],
        line: 27
      },
      '1': {
        loc: {
          start: {
            line: 29,
            column: 9
          },
          end: {
            line: 43,
            column: 3
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 29,
            column: 9
          },
          end: {
            line: 43,
            column: 3
          }
        }, {
          start: {
            line: 29,
            column: 9
          },
          end: {
            line: 43,
            column: 3
          }
        }],
        line: 29
      },
      '2': {
        loc: {
          start: {
            line: 31,
            column: 9
          },
          end: {
            line: 43,
            column: 3
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 31,
            column: 9
          },
          end: {
            line: 43,
            column: 3
          }
        }, {
          start: {
            line: 31,
            column: 9
          },
          end: {
            line: 43,
            column: 3
          }
        }],
        line: 31
      },
      '3': {
        loc: {
          start: {
            line: 33,
            column: 9
          },
          end: {
            line: 43,
            column: 3
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 33,
            column: 9
          },
          end: {
            line: 43,
            column: 3
          }
        }, {
          start: {
            line: 33,
            column: 9
          },
          end: {
            line: 43,
            column: 3
          }
        }],
        line: 33
      },
      '4': {
        loc: {
          start: {
            line: 35,
            column: 9
          },
          end: {
            line: 43,
            column: 3
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 35,
            column: 9
          },
          end: {
            line: 43,
            column: 3
          }
        }, {
          start: {
            line: 35,
            column: 9
          },
          end: {
            line: 43,
            column: 3
          }
        }],
        line: 35
      },
      '5': {
        loc: {
          start: {
            line: 37,
            column: 9
          },
          end: {
            line: 43,
            column: 3
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 37,
            column: 9
          },
          end: {
            line: 43,
            column: 3
          }
        }, {
          start: {
            line: 37,
            column: 9
          },
          end: {
            line: 43,
            column: 3
          }
        }],
        line: 37
      },
      '6': {
        loc: {
          start: {
            line: 39,
            column: 9
          },
          end: {
            line: 43,
            column: 3
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 39,
            column: 9
          },
          end: {
            line: 43,
            column: 3
          }
        }, {
          start: {
            line: 39,
            column: 9
          },
          end: {
            line: 43,
            column: 3
          }
        }],
        line: 39
      },
      '7': {
        loc: {
          start: {
            line: 44,
            column: 2
          },
          end: {
            line: 50,
            column: 3
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 44,
            column: 2
          },
          end: {
            line: 50,
            column: 3
          }
        }, {
          start: {
            line: 44,
            column: 2
          },
          end: {
            line: 50,
            column: 3
          }
        }],
        line: 44
      },
      '8': {
        loc: {
          start: {
            line: 47,
            column: 4
          },
          end: {
            line: 49,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 47,
            column: 4
          },
          end: {
            line: 49,
            column: 5
          }
        }, {
          start: {
            line: 47,
            column: 4
          },
          end: {
            line: 49,
            column: 5
          }
        }],
        line: 47
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0
    },
    f: {
      '0': 0,
      '1': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0],
      '3': [0, 0],
      '4': [0, 0],
      '5': [0, 0],
      '6': [0, 0],
      '7': [0, 0],
      '8': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

cov_1n660e8fu6.s[0]++;
angular.module('app', ['ngSanitize', 'ui.router', // Routing
'oc.lazyLoad', // ocLazyLoad
'ui.bootstrap', // Ui Bootstrap
'pascalprecht.translate', // translateProvider
'delaHttp', 'deltadate', 'angularFileUpload', 'delaStore', 'chart.js', 'tmh.dynamicLocale', 'oitozero.ngSweetAlert', 'ui.checkbox', 'colorpicker.module', 'ui.select', 'localytics.directives', 'summernote', 'angular-peity', 'datePicker']).config(['tmhDynamicLocaleProvider', function (tmhDynamicLocaleProvider) {
  cov_1n660e8fu6.f[0]++;
  cov_1n660e8fu6.s[1]++;

  tmhDynamicLocaleProvider.localeLocationPattern('https://cdnjs.cloudflare.com/ajax/libs/angular-i18n/1.6.8/angular-locale_{{locale}}.min.js');
}]);
cov_1n660e8fu6.s[2]++;
Date.newDate = function (p1, p2, p3, p4, p5, p6, p7) {
  cov_1n660e8fu6.f[1]++;

  var result = (cov_1n660e8fu6.s[3]++, null);
  cov_1n660e8fu6.s[4]++;
  if (angular.isUndefined(p1)) {
    cov_1n660e8fu6.b[0][0]++;
    cov_1n660e8fu6.s[5]++;

    result = new Date();
  } else {
      cov_1n660e8fu6.b[0][1]++;
      cov_1n660e8fu6.s[6]++;
      if (angular.isUndefined(p2)) {
        cov_1n660e8fu6.b[1][0]++;
        cov_1n660e8fu6.s[7]++;

        result = new Date(p1);
      } else {
          cov_1n660e8fu6.b[1][1]++;
          cov_1n660e8fu6.s[8]++;
          if (angular.isUndefined(p3)) {
            cov_1n660e8fu6.b[2][0]++;
            cov_1n660e8fu6.s[9]++;

            result = new Date(p1, p2);
          } else {
              cov_1n660e8fu6.b[2][1]++;
              cov_1n660e8fu6.s[10]++;
              if (angular.isUndefined(p4)) {
                cov_1n660e8fu6.b[3][0]++;
                cov_1n660e8fu6.s[11]++;

                result = new Date(p1, p2, p3);
              } else {
                  cov_1n660e8fu6.b[3][1]++;
                  cov_1n660e8fu6.s[12]++;
                  if (angular.isUndefined(p5)) {
                    cov_1n660e8fu6.b[4][0]++;
                    cov_1n660e8fu6.s[13]++;

                    result = new Date(p1, p2, p3, p4);
                  } else {
                      cov_1n660e8fu6.b[4][1]++;
                      cov_1n660e8fu6.s[14]++;
                      if (angular.isUndefined(p6)) {
                        cov_1n660e8fu6.b[5][0]++;
                        cov_1n660e8fu6.s[15]++;

                        result = new Date(p1, p2, p3, p4, p5);
                      } else {
                          cov_1n660e8fu6.b[5][1]++;
                          cov_1n660e8fu6.s[16]++;
                          if (angular.isUndefined(p7)) {
                            cov_1n660e8fu6.b[6][0]++;
                            cov_1n660e8fu6.s[17]++;

                            result = new Date(p1, p2, p3, p4, p5, p6);
                          } else {
                            cov_1n660e8fu6.b[6][1]++;
                            cov_1n660e8fu6.s[18]++;

                            result = new Date(p1, p2, p3, p4, p5, p6, p7);
                          }
                        }
                    }
                }
            }
        }
    }cov_1n660e8fu6.s[19]++;
  if (result) {
    cov_1n660e8fu6.b[7][0]++;

    var UTCday = (cov_1n660e8fu6.s[20]++, result.getUTCDate());
    var day = (cov_1n660e8fu6.s[21]++, result.getDate());
    cov_1n660e8fu6.s[22]++;
    if (UTCday != day) {
      cov_1n660e8fu6.b[8][0]++;
      cov_1n660e8fu6.s[23]++;

      result.setMinutes(result.getMinutes() + result.getTimezoneOffset());
    } else {
      cov_1n660e8fu6.b[8][1]++;
    }
  } else {
    cov_1n660e8fu6.b[7][1]++;
  }

  cov_1n660e8fu6.s[24]++;
  return result;
};